import { render, staticRenderFns } from "./WorkflowFormBuilderTodoTemplatePicker.vue?vue&type=template&id=1967019b&"
import script from "./WorkflowFormBuilderTodoTemplatePicker.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderTodoTemplatePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports